import { render, staticRenderFns } from "./KnTable.vue?vue&type=template&id=09b02930&"
import script from "./KnTable.vue?vue&type=script&lang=js&"
export * from "./KnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports